import clsx from 'clsx';
import type { ReactNode } from 'react';

export type ContentWithLoadingProps = {
  loading: boolean;
  children: ReactNode;
  /** When true and not loading, shows empty state instead of children */
  empty?: boolean;
  emptyTitle?: string;
  emptySubtitle?: string;
  loadingMessage?: string;
  /** Applied to the outer wrapper (e.g. for grid cell span) */
  className?: string;
};

export function ContentWithLoading({
  loading,
  empty = false,
  emptyTitle,
  emptySubtitle,
  loadingMessage = 'Loading...',
  className,
  children,
}: ContentWithLoadingProps) {
  if (loading) {
    return (
      <div
        className={clsx(
          'flex justify-center items-center py-10 text-gray-500 text-base font-medium col-span-full',
          className
        )}
      >
        {loadingMessage}
      </div>
    );
  }

  if (empty) {
    return (
      <div className={clsx('flex flex-col justify-center items-center py-10 gap-4 col-span-full', className)}>
        {emptyTitle && <div className="text-[#767676] text-lg font-medium text-center">{emptyTitle}</div>}
        {emptySubtitle && <div className="text-[#B2B2B2] text-sm font-normal text-center">{emptySubtitle}</div>}
      </div>
    );
  }

  return <>{children}</>;
}
